export const CREATE_SESSION = "CREATE_SESSION";
export const LOAD_CONFIG = "LOAD_CONFIG";
export const RESET_FOR_MODEL_SELECTOR = "RESET_FOR_MODEL_SELECTOR";
export const SET_SESSION_DATA = "SET_SESSION_DATA";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_VIRTUAL_KEYBOARD = "SET_VIRTUAL_KEYBOARD";
export const START_IN_PRESET_SESSION = "START_IN_PRESET_SESSION";
